import React, { Component } from "react";
import Countdown from 'react-countdown';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from "react-router-dom";

class Countdowncode extends Component {

  constructor(props) {
    super(props)
    this.state = {
      timeDown: Date.now() + 300000
    }
  }

  componentDidMount() {

  }

  render(){
    return(
      <Countdown
        date={ this.state.timeDown }
        daysInHours={false}
        zeroPadDays={0}
        precision={3}
        onComplete={() => {
          alert('Lo sentimos, el tiempo de confirmación expiró. Prueba con otro método de autenticación.')
          window.location.reload()
        }}
      />
    )
  }

}

export default withRouter(Countdowncode)